import { Component, OnInit } from '@angular/core';
import { NotificationsService } from '../services/notifications.service';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-notice-board',
  templateUrl: './notice-board.component.html',
  styleUrls: ['./notice-board.component.css']
})
export class NoticeBoardComponent implements OnInit {

  constructor(public notificationService: NotificationsService, public log: LogService) { }
  
  public allNoticeArray: any= [];
  public filteredNoticeArr: any = [];
  public spinner = true;
  public message = "";
  public empty = false;
  public searchNotice = "";
  public filterUrgency = "";

  ngOnInit() {
    this.getAllNotice();
    this.log
      .addLog({
      action: "Access",
      component: "Notice Board",
      details: `Access Notice Board`,
    }).subscribe(data => { });
  }


  getAllNotice () {
    this.notificationService.getAllNoticeFromNoticeBoard().subscribe(data => {
      this.allNoticeArray = data;
      this.filteredNoticeArr = data;
      if (this.allNoticeArray.length <= 0) {
        this.empty = true;
        this.message = "Notice Board is empty"
      } else {
        this.empty = false;
        this.message = "";
      }
      this.spinner = false;
    })
  }

  filterNotice (selectby) {
    if(this.filterUrgency == "10"){
      this.filteredNoticeArr = this.allNoticeArray;
      return;
    } 
    if (selectby == "urgency") {
      this.filteredNoticeArr = this.allNoticeArray.filter(n => n.notice_urgency == this.filterUrgency);
    }
  }



}
